/**
 * periodLensItems — rows → LensePanel items (v2 redesign). The panel is a FLAT
 * period filter: one entry per crop year (newest first, "Ohne Jahr" last) with
 * that period's row count.
 *
 * There is deliberately NO second level (removed 2026-07-16 on the user's
 * request): a real farm-year holds dozens of crop_cycles, so per-cycle children
 * turned the sidebar into an unreadable wall that duplicated the chart + table.
 * The crop rows live in the chart and the ranked table, which remain the ?cc=
 * deep-link surfaces (stable #cc-<id> anchor contract, unchanged).
 */
import type { LenseItem } from '@hofsync/design-system';
import { periodLabel, periodsOf, rowsForPeriod } from './deckungsbeitragRollup';
import type { DeckungsbeitragRow } from './types';

export function periodLensItems(rows: DeckungsbeitragRow[], wjStartMonth: number): LenseItem[] {
  return periodsOf(rows).map((period) => ({
    id: period,
    name: periodLabel(period === 'ohne-jahr' ? null : period, wjStartMonth),
    count: rowsForPeriod(rows, period).length,
  }));
}
